export default __webpack_public_path__ + "static/media/business-analyst.41a4c49d.gif";